<template>
  <div class="text-center">
    <v-btn @click="dialog = !dialog">
      <span class="mr-2">Import XML</span>
    </v-btn>

    <v-dialog v-model="dialog" width="500" hide-overlay>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Import XML</v-card-title>

        <div class="ml-5 mr-5">
          <v-file-input @change="addFile"></v-file-input>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="upload">Import</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import parseProject from "src/util/parseProject";

export default {
  data() {
    return {
      file: null,
      dialog: false,
    };
  },
  methods: {
    async addFile(file) {
      this.file = file;
    },

    async upload() {
      this.dialog = false;

      const data = new FormData();
      data.append("file", this.file);

      const response = await fetch(
        `${process.env.VUE_APP_API_BASE_URL}/upload-project`,
        {
          method: "POST",
          body: data,
        }
      );

      if (response.ok) {
        const project = await response.json();
        this.$store.dispatch("updateProject", parseProject(project));
      }

      this.file = null;
    },
  },
};
</script>
